// extracted by mini-css-extract-plugin
module.exports = {"title":"FormSale_title__Nmq8t","wrapperInput":"FormSale_wrapperInput__3hqBF","wrapperSubmit":"FormSale_wrapperSubmit__8MrE9","iconCheck":"FormSale_iconCheck__3dndI"};